module.exports = __webpack_public_path__ + "img/cc3623_center_002.3a9c436e.png";